import Styled, { css } from "styled-components";
import { px2rem } from "utils/browser/resizer";

const PictureTagBase = Styled.img`
	position: absolute;
	z-index: 2;
`;

export const RightTopTag = Styled(PictureTagBase)`
	height: auto;
	top: 0;
	right: 0;
	${(props: { gridCol: number }) => {
		switch (props.gridCol) {
			case 1:
				return css`
					max-width: 1.6875rem;
					max-height: 1.6875rem;
				`;
			case 2:
				return css`
					max-width: 1.875rem;
					max-height: 1.875rem;
				`;
		}
		return "";
	}}
`;

export const NewRightTopTag = Styled(PictureTagBase)`
	top: 0;
	right: 0;
	border-radius: 0 0.25rem 0px 0;
	transform: scale(0.333);
    transform-origin: top right;
	max-height: 100%;
`;

export const LeftTopTag = Styled(PictureTagBase)`
	top: 0;
	left: 0;
	${(props: { gridCol: number }) => {
		switch (props.gridCol) {
			case 1:
				return css`
					max-height: 0.875rem;
				`;
			case 2:
				return css`
					max-height: 2.5rem;
					max-width: 47%;
				`;
		}
		return "";
	}}
`;

export const LeftTopTags = Styled.div`
	top: 0;
	left: 0;
	position: absolute;
	z-index: 2;
	border-top-left-radius: 0.25rem;
	border-bottom-right-radius: ${px2rem(8)};
	>img{
		height: ${px2rem(16)};
		width: auto;
		object-fit: cover;
		&:first-child{
			border-top-left-radius: ${px2rem(4)};
		}
		&:last-child{
			border-bottom-right-radius: ${px2rem(8)};
		}
	}	
`;

export const LeftBottomTag = Styled(PictureTagBase)`
	height: 1.375rem;
	bottom: 0;
	left: 0;
`;
